import { Skeleton } from '@/components/_ui/Skeleton'
import { useGetPromosProductData } from '@/lib/hooks/services/useGetPromoProductData'
import type { HydraErrorType } from '@/lib/services/Hydra/_hydraError'
import { ErrorAlert } from '@/components/_ui/ErrorAlert'
import { PromoItem } from './CartSheetPromoItem'

type Props = {
  isLoadingOrderCalculation: boolean
  orderCalculationError: HydraErrorType | null
}

const CartSheetPromoItems = ({
  isLoadingOrderCalculation,
  orderCalculationError,
}: Props) => {
  const { isLoading, promoItems } = useGetPromosProductData()

  if (orderCalculationError) {
    return <ErrorAlert error={orderCalculationError} />
  }

  if (isLoading || isLoadingOrderCalculation) {
    return <Skeleton className="flex h-24 flex-row rounded-lg" />
  }

  if (!promoItems || promoItems.length === 0) return null

  return promoItems.map((product) => (
    <PromoItem key={product.data.slug} product={product} />
  ))
}

export default CartSheetPromoItems
